import React from 'react';
/**
 * A default fallback Error component
 *
 * @todo Make this look nice and show a reasonable message and/or a retry button
 * via props.resetErrorBoundary
 */
export var FallbackError = function (_props) {
    return React.createElement(React.Fragment, null);
};
//# sourceMappingURL=FallbackError.js.map